import { ProductSegmentConfigTypes } from '../../../types/ProductTypes';

import { ProductSegmentConfigDTO } from '../../dtos/product.dtos';

export const getProductSegmentConfigTransformer = (
  data: ProductSegmentConfigTypes
): ProductSegmentConfigDTO | undefined => {
  return data
    ? ({
        shouldSendSegmentEvent: data.should_send_segment_event,
        segmentEventsTypes: data.segment_events_types
          ? data.segment_events_types
          : undefined,
        googleAnalyticsEvents: data.google_analytics_events
      } as ProductSegmentConfigDTO)
    : undefined;
};
